import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  Flex,
  useClipboard,
  Input,
  InputGroup,
  InputRightElement,
  Alert,
  AlertIcon,
  HStack,
  Link,
  SimpleGrid,
} from '@chakra-ui/react';
import { getRegistryAdmin } from '../services/RegistryService';
import { shareOnFacebook, shareViaEmail, shareViaText } from '../utils/sharingUtils';

const RegistrySuccess = () => {
  const { registryId } = useParams<{ registryId: string }>();
  const [registry, setRegistry] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const registryUrl = `${window.location.origin}/registry/${registryId}`;
  const adminUrl = `${window.location.origin}/registry/${registryId}`;
  const memberUrl = `${window.location.origin}/registry/${registryId}`;
  
  const { hasCopied, onCopy } = useClipboard(registryUrl);
  const { hasCopied: hasAdminCopied, onCopy: onAdminCopy } = useClipboard(adminUrl);
  const { hasCopied: hasMemberCopied, onCopy: onMemberCopy } = useClipboard(memberUrl);

  const handleShareOnFacebook = () => shareOnFacebook(registryUrl);
  const handleShareViaEmail = () => shareViaEmail(registryUrl, registry?.parentNames);
  const handleShareViaText = () => shareViaText(registryUrl);
  
  useEffect(() => {
    const fetchRegistry = async () => {
      if (!registryId) {
        setError('No registry ID provided');
        setLoading(false);
        return;
      }
      
      try {
        const registryData = await getRegistryAdmin(registryId);
        if (registryData) {
          setRegistry(registryData);
        } else {
          setError('Registry not found');
        }
      } catch (err) {
        console.error('Error fetching registry:', err);
        setError('Failed to load registry details');
      } finally {
        setLoading(false);
      }
    };
    
    fetchRegistry();
  }, [registryId]);
  
  return (
    <Container maxW="container.md" py="10">
      <VStack spacing="8" textAlign="center">
        <Heading as="h1" size="xl" >
          MommaFuel Created Successfully!
        </Heading>
        
        <Box bg="white" p="6" borderRadius="lg" shadow="md" width="100%">
          <VStack spacing="4">
            
            {registry && (
              <Text fontWeight="bold">
                For {registry.parentNames} - Due Date: {registry.dueDate.split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, (_: string, year: string, month: string, day: string) => {
                  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
                  return date.toLocaleDateString();
                })}
              </Text>
            )}
            
            <Box width="100%" borderWidth="1px" borderRadius="md" p="4" bg="white">
              <Heading size="sm" mb="2">Share Your MommaFuel</Heading>
              <InputGroup size="md">
                <Input
                  pr="4.5rem"
                  type="text"
                  value={registryUrl}
                  isReadOnly
                />
                <InputRightElement width="4.5rem">
                  <Button h="1.75rem" size="sm" onClick={onCopy}>
                    {hasCopied ? "Copied" : "Copy"}
                  </Button>
                </InputRightElement>
              </InputGroup>

              <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4} mt={4}>
                <Button
                  colorScheme="blue"
                  onClick={handleShareViaEmail}
                  size="sm"
                  height="auto"
                  py={2}
                  whiteSpace="normal"
                  textAlign="center"
                >
                  Email
                </Button>
                <Button
                  colorScheme="green"
                  onClick={handleShareViaText}
                  size="sm"
                  height="auto"
                  py={2}
                  whiteSpace="normal"
                  textAlign="center"
                >
                  Text
                </Button>
                <Button
                  colorScheme="facebook"
                  onClick={handleShareOnFacebook}
                  size="sm"
                  height="auto"
                  py={2}
                  whiteSpace="normal"
                  textAlign="center"
                >
                  Facebook: Copy & Share
                </Button>
              </SimpleGrid>
            </Box>
          </VStack>
        </Box>
        
        <Flex gap="4" justifyContent="center">
          <Button
            as={RouterLink}
            to={`/registry/${registryId}`}
            variant="primary"
            
          >
            View My MommaFuel
          </Button>
        </Flex>
      </VStack>
    </Container>
  );
};

export default RegistrySuccess; 